import React from "react";

const ActivityTour = ({ setStepsEnabled, setHomeScreenWalkThroughPopup }) => {
  return (
    <div className="ContainerSubmitedSucess2 ">
      <div className="SubContainerSubmitedSucess innerContainerFlex">
        <div className="imageContainer">
          <img src="/gif/activity_guide.gif" alt="" />
        </div>
        <div className="rightContainer">
          <div className="studentLogos leftMargin">
            <div></div>
            <div>
              <img
                src="/StudentImg/BreathSchoolLogo.png"
                alt="icon"
                width={"30px"}
              ></img>
            </div>
          </div>
          <div className=" overallMarginHead" style={{ position: "relative" }}>
            <h4 className="textColor1"> Welcome to Activity Section</h4>
            <img style={{ width: "35px", height: "35px", position: "absolute", left: "87%", top: "195px", cursor: "pointer", zIndex: "999" }} src="./images/down_arrow.png" alt="arrowimag" onClick={() => {
              document.getElementById("last-paragraph").scrollIntoView({ behavior: "smooth" })
            }} />
          </div>

          <div className=" overallMargin">
            <p className="textColor2">
              1. Master the Curriculum Concepts through Activities based Experiential Learning.
            </p>
            <hr></hr>
            <p className="textColor2" >
              2. Enjoy Doing Activities with your Parents and Enrich the Parental Bondings.
            </p>
            <hr></hr>
            <p className="textColor2">
              3. Access all the Activities at Anytime and from Anywhere.
            </p>
            <hr></hr>
            <p className="textColor2" >
              4. Personalized Sharing of Remedial Materials and Evaluation from Teachers.
            </p>
            <hr></hr>
            <p className="textColor2" >
              5. Boosts Critical Thinking Skills and Enhances Problem-Solving Abilities.
            </p>
            <hr></hr>
            <p className="textColor2" >
              6. Connects Theory to Real-Life Scenarios and Builds Confidence Through Practice.
            </p>
            <hr></hr>
            <p className="textColor2" id="last-paragraph">
              7. Makes Learning Fun and Interactive and Improves Knowledge Retention.
            </p>
            <hr></hr>
          </div>

          <div className="buttonsContainer">
            <button
              className="rightBtn"
              onClick={() => {
                setHomeScreenWalkThroughPopup(false);
                setStepsEnabled(true);
              }}
            >
              Take me to the product tour
            </button>
            <button
              className="leftBtn"
              onClick={() => setHomeScreenWalkThroughPopup(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityTour;
